<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row" v-if="userData.permissions['view_investment_returns']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary"  @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button></div>
              </div>
              <span class="mt-3"><b-button v-show="userData.permissions['new_loan_products']==1" v-b-modal.new-return size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Returns</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(amount)="data">
                {{ commas(data.item.amount) }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
              </template>
              <template #cell(investment)="data">
                <b>{{ data.item.investment.name }}</b><br>
                <small>{{ data.item.investment.location }}</small>
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.investment.id,data.item.amount,data.item.date_of_payment )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.investment.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
                <div class="col">
                    <b>Total Returns : {{ commas(totalreturns) }}</b>
                </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Investments</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-return" centered title="New Returns" title-class="font-18" hide-footer>
        <form @submit.prevent="addReturns">
            <div class="form-group mb-2">
              <label>Investment</label> <small class="text-danger">*</small>
              <v-select :options="investments" placeholder="Select an Option" v-model="investment" label="name" :reduce="investment => investment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            <label>Date Received</label>
            <input v-model="dateofpayment" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-return')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-return" centered title="Edit Returns" title-class="font-14" hide-footer>
        <form @submit.prevent="editReturns">
            <div class="form-group mb-2">
              <label>Investment</label> <small class="text-danger">*</small>
              <v-select :options="investments" placeholder="Select an Option" v-model="investment" label="name" :reduce="investment => investment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            <label>Date Received</label>
            <input v-model="dateofpayment" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-return')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-return" centered title="Delete Returns" title-class="font-18" hide-footer>
        <form @submit.prevent="removeReturns">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Returns : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-return')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
 
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { investmentMethods, investmentComputed, investmentreturnMethods, investmentreturnComputed } from "@/state/helpers";

export default {
  page: {
    title: "Investment Returns",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Investment Returns",
      items: [ {text: "Dashboard",to: "/",}, {text: "Investment Returns",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'investment', label: 'Investment', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'date_of_payment', label: 'Date Received', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      dateofpayment:new Date().toLocaleDateString('fr-CA'),
      amount:'',
      investment:'',
      date_to:new Date().toLocaleDateString('fr-CA'),
      date_from:new Date().toLocaleDateString('fr-CA'),
    };
  },
  computed: {
    ...investmentComputed,
    ...investmentreturnComputed,
    List() { return this.investmentreturns.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.investmentreturns.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.investmentreturns.length>0) { a=false;} else { a=true;} return a },
    totalreturns(){ var total = 0; this.investmentreturns.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
  },
  mounted() {
    this.fetchInvestmentReturns();
    this.fetchInvestments();
    this.TotalRows = this.investmentreturns.length;
    this.isBusy=false;
  },
  methods: {
    ...investmentMethods,
    ...investmentreturnMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    edit(id,investment,amount,date_of_payment){
      this.id=id;
      this.investment=investment;
      this.amount=amount;
      this.date_of_payment=date_of_payment;
      this.$bvModal.show('edit-return')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-return')
    },
    async addReturns() { 
      let formData = new FormData();
      formData.append("investment", this.investment);
      formData.append("amount", this.amount);
      formData.append("date_of_payment", this.dateofpayment);
      let url = "/addinvestmentreturn";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchInvestmentReturns();
          this.$bvModal.hide('new-return');
          this.investment="";
          this.amount="";
      }
      });
    },
    async editReturns(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("investment", this.investment);
    formData.append("amount", this.amount);
    formData.append("date_of_payment", this.dateofpayment);
    let url = "/updateinvestmentreturn";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchInvestmentReturns();
        this.$bvModal.hide('edit-return');
        this.investment="";
        this.amount="";
      }
    });
    },
    async removeReturns() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeinvestmentreturn";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchInvestmentReturns();
        this.$bvModal.hide('delete-return');
      }
    });
    },
    FilterData() {
      this.filterInvestmentReturns({datefrom:this.date_from,dateto:this.date_to});
    },
  },
};
</script>